module.exports = {
  label: {
    companyName: 'Smart Visitor',
  }
}